import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LeafletMarkerClusterModule } from '@asymmetrik/ngx-leaflet-markercluster';
import { FcOutlinedSelectModule } from '@core/components/fc-select/base/fc-outlined-select/fc-outlined-select.module';
import { FcCompanyOutlinedSelectModule } from '@core/components/fc-select/search-one/fc-company-outlined-select/fc-company-outlined-select.module';
import { FcSegmentOutlinedSelectModule } from '@core/components/fc-select/search-one/fc-segment-outlined-select/fc-segment-outlined-select.module';
import { AddressModule } from '@core/components/inputs/address/address.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { QueryAddressCoordinatesGQL, QueryAddressGeocodeGQL, QueryAddressPostalCodeGQL, QueryCoordinatesGeocodeGQL } from '../../../main/locations/services/location.service';
import { MapAddressComponent } from './map-address.component';

@NgModule({
  declarations: [
    MapAddressComponent,
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    LeafletModule,
    LeafletMarkerClusterModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    AddressModule,
    FcOutlinedSelectModule,
    FcSegmentOutlinedSelectModule,
    FcCompanyOutlinedSelectModule,
  ],
  exports: [
    MapAddressComponent
  ],
  providers: [
    QueryAddressGeocodeGQL,
    QueryAddressPostalCodeGQL,
    QueryCoordinatesGeocodeGQL,
    QueryAddressCoordinatesGQL,
  ]
})
export class MapAddressModule {}
